import {
	Component,
	ElementRef,
	HostListener,
	OnInit,
	QueryList,
	TemplateRef,
	ViewChild,
	ViewChildren
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { State } from 'src/app/shared/enums/state.enum';
import { Address } from 'src/app/shared/models/address';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Mission } from 'src/app/shared/models/mission/mission';
import { Route } from 'src/app/shared/models/route';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import {
	Map,
	MarkerOptions,
	Marker,
	Icon,
	tileLayer,
	latLng,
	LatLng,
	LocationEvent,
	marker,
	LatLngExpression,
	polyline
} from 'leaflet';
import 'leaflet-arrowheads';
import { ReorderRouteComponent } from '../reorder-route/reorder-route.component';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { User } from 'src/app/shared/models/security/user';
import {
	CompetencesElementaires,
	hasEmployeeSkill
} from 'src/app/shared/enums/competence.enum';
// import 'node_modules/leaflet-arrowheads/src/index.js';
@Component({
	selector: 'app-daily-routes',
	templateUrl: './daily-routes.component.html',
	styleUrls: ['./daily-routes.component.scss']
})
export class DailyRoutesComponent implements OnInit {
	user: User = null;
	sessad_coord: number[] = [47.464436, -0.605093];
	sessad_name = 'Institut Montéclair';

	@ViewChild('accordionMission', { static: false })
	accordionMission: ElementRef;

	@ViewChildren('routeDropdownListing') routeDropdowns: QueryList<ElementRef>;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive = false;

	/**
	 * Icone de la position actuel sur la carte (vrai coordonnée si tracking gps, sinon coordonnée du centre)
	 */
	currentPosition: number[] = this.sessad_coord;

	/**
	 * Carte
	 */
	map: Map = null;

	/**
	 * Options de la carte
	 */
	options = {};

	/**
	 * Vol d'oiseau
	 */
	isCrowflightSelected = true;

	/**
	 * Elements dessiner
	 */
	layers = [];

	/**
	 * Liste des centres
	 */
	listCenter: ServiceCenter[] = [];

	/**
	 * Routes recuperées
	 */
	listRoute: Route[] = [];

	stateEnum = State;

	/**
	 * Filtre des routes (tournée en études,en attente,en cours, etc)
	 */
	etat: State = State.UNDER_REVIEW;
	stateKey: string = 'etude';

	mappingState = {
		etude: State.UNDER_REVIEW,
		attente: State.PENDING,
		'en-cours': State.IN_PROGRESS
	};

	/**
	 * Routes à afficher sur la carte
	 */
	listRouteToDrawOnMap: Route[] = [];

	/**
	 * Mode plein ecran
	 */
	isFullScreen = false;

	/**
	 * Index de la seule route (de listRouteToDrawOnMap) à afficher
	 */
	selectedRouteIndex: number = null;

	/**
	 * Date du jour
	 */
	currentDate: Date = null;

	monthsFr = [
		'janvier',
		'février',
		'mars',
		'avril',
		'mai',
		'juin',
		'juillet',
		'aout',
		'septembre',
		'octobre',
		'novembre',
		'décembre'
	];

	/**
	 * Icone à afficher pour les centres
	 */
	iconCentre = new Icon({
		iconUrl: '../../../../assets/img/icons/house-fill.svg',
		iconSize: [40, 40]
	});

	/**
	 * Icone à afficher pour les missionPlaces
	 */
	iconMissionPlace = new Icon({
		iconUrl: '../../../../assets/img/icons/mortarboard-fill.svg',
		iconSize: [40, 50]
	});

	/**
	 * Icones à afficher pour les SAAD/SIAD
	 */
	missionDefaultIcon = new Icon({
		iconUrl: ' ../../../../assets/img/icons/map-icon-mission-default.svg',
		iconSize: [40, 45]
	});

	missionOnTheWayIcon = new Icon({
		iconUrl: ' ../../../../assets/img/icons/map-icon-mission-on-the-way.svg',
		iconSize: [40, 45]
	});

	missionInProgressIcon = new Icon({
		iconUrl: ' ../../../../assets/img/icons/map-icon-mission-in-progress.svg',
		iconSize: [40, 45]
	});

	missionFinishedIcon = new Icon({
		iconUrl: ' ../../../../assets/img/icons/map-icon-mission-finished.svg',
		iconSize: [40, 45]
	});

	missionCanceledIcon = new Icon({
		iconUrl: ' ../../../../assets/img/icons/map-icon-mission-canceled.svg',
		iconSize: [40, 45]
	});

	/**
	 * Option pour les marqueurs des centre à dessiner
	 */
	markerOptionsCentre: MarkerOptions = {
		icon: this.iconCentre,
		draggable: false
	};

	/**
	 * Option pour les marqueurs des missions à dessiner
	 */
	markerOptionsMission: MarkerOptions = {
		icon: this.missionDefaultIcon,
		draggable: false
	};

	/**
	 * Couleur des routes
	 */
	colorsPathOld: string[] = [
		'#f19eaf', //pink
		'#668bc7', //blue
		'#8dcdcb', //green
		'#ed7387', //red
		'#a3acd8', //violet
		'#262c5e', //darkblue
		'#484e7f',
		'#4c416d',
		'#5b6392',
		'#6b94c8',
		'#6b537a',
		'#7078a6',
		'#79abc9',
		'#805f82',
		'#8890be',
		'#84beca',
		'#9e708e',
		'#b9aacd',
		'#91cbca',
		'#ba7f99',
		'#9fb1d6',
		'#c7a7c6',
		'#a4c2c5',
		'#d890a5',
		'#98bcd2',
		'#dca2ba',
		'#bfb5bd',
		'#92c6ce',
		'#d8aab6',
		'#f096a8'
	];

	colorsPath: string[] = [
		'#262c5e', // darkblue
		'#484e7f',
		'#4c416d',
		'#5b6392',
		'#6b537a',
		'#7078a6',
		'#6b94c8',
		'#805f82',
		'#8890be',
		'#9e708e',
		'#9fb1d6',
		'#b9aacd',
		'#ba7f99',
		'#bfb5bd',
		'#d8aab6'
	];

	labelBeneficiaire: string;
	labelIntervention: string;

	/**
	 * Référence de la modal
	 */
	modalRef?: BsModalRef;

	/**
	 * Tout les employées
	 */
	listEmployee: Employee[] = [];

	/**
	 * Liste des employées disponibles pour la réaffectation de la route, i.e les employées qui ne sont pas déjà affecter à une route.
	 */
	listEmployeeAvailableRoute: Employee[] = [];

	/**
	 * Liste des employées disponibles pour la réaffectation d'une mission, i.e les employées déjà affecter à une route
	 */
	listEmployeeAvailableMission: Employee[] = [];

	/**
	 * Id de l'employee pour la réafectation de la route
	 */
	idEmployeeReafectation: number = null;

	/**
	 * Route à réaffecter
	 */
	selectedRouteForReaffect: Route = null;

	/**
	 * Mission à réaffecter or supprimer
	 */
	selectedMisionForReaffectOrDelete: Mission = null;

	/**
	 * Liste des marqueurs de la map associés aux missions
	 */
	missionMarkerList: Marker[] = [];

	isBtnValidateRouteClicked = false;
	isBtnSaveRouteClicked = false;
	isBtnDeplacerClicked = false;
	isBtnReaffecterClicked = false;
	isBtnSupprimerClicked = false;

	isMobile = false;
	screenWidth: number;

	selectedDate: Date;
	currentRouteStateSelected: any;
	static selectedRouteIndex: number;

	isSolutionValidated: boolean = false;

	layersControl: { baseLayers: any; overlays: any };

	/**
	 *
	 * @param logger
	 * @param facade
	 * @param dateUtils
	 */
	constructor(
		// private constantsService: ConstantsService,
		private logger: LogService,
		private facade: FacadeService,
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private toastService: ToastService,
		private dateUtils: DateUtils
	) {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
	}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();
		this.stateKey = this.router.url.split('/').pop();
		this.currentRouteStateSelected = this.mappingState[this.stateKey];

		if (this.facade.dataStorageService.getParam('selectedRouteIndex')) {
			this.selectedRouteIndex =
				this.facade.dataStorageService.getParam('selectedRouteIndex');
		}
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.isAreaActive = this.facade.dataStorageService.isAreaActive();

		const addressCenter: Address =
			this.facade.dataStorageService.getUser()?.employee.serviceCenter.address;
		this.sessad_name =
			this.facade.dataStorageService.getUser()?.employee.serviceCenter.name;
		this.sessad_coord = [addressCenter?.latitude, addressCenter?.longitude];
		this.currentPosition = this.sessad_coord;

		const osm = tileLayer(
			'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			{
				maxZoom: 18,
				attribution: '...'
			}
		);
		const stadiaMap = tileLayer(
			'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png',
			{ maxZoom: 18, attribution: '...' }
		);

		this.layersControl = {
			baseLayers: {
				'Stadia Map': stadiaMap,
				'OpenStreet Map': osm
			},
			overlays: {}
		};

		this.options = {
			layers: [osm, stadiaMap],
			zoom: 15,
			center: latLng(this.sessad_coord[0], this.sessad_coord[1]),
			zoomControl: false
		};

		this.labelBeneficiaire = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_BENEFICIAIRE
		);
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		this.facade.employeeService
			.getAllActiveEmployees()
			.subscribe((employees) => (this.listEmployee = employees));

		this.listRoute = [];

		this.updateSelectedDate();

		const weekNumber = this.dateUtils.getWeekNumber(this.selectedDate);
		const year = this.selectedDate.getFullYear();

		this.facade.solutionService
			.isSolutionValidated(year, weekNumber)
			.subscribe((validated) => {
				this.isSolutionValidated = validated;
				this.getRoutesForDay();
			});

		/*
		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationStart) {
				console.log(event.url);
				// lancer la récup automatique des états de mission, ou l'arrêter si on change de route
				let onLoginPage = event.url === '/login';
			}
		});*/
	}

	updateSelectedDate() {
		if (this.facade.dataStorageService.getParam('selectedDate')) {
			this.selectedDate = new Date(
				this.facade.dataStorageService.getParam('selectedDate')
			);
		} else {
			if (
				this.facade.dataStorageService.getParam('storedCalendarWeeknumber') &&
				this.facade.dataStorageService.getParam('storedCalendarYearnumber')
			) {
				this.selectedDate = new Date(
					this.dateUtils.getDateOfISOWeek(
						this.facade.dataStorageService.getParam('storedCalendarWeeknumber'),
						this.facade.dataStorageService.getParam('storedCalendarYearnumber')
					)
				);
			} else {
				let nextWeekDate = new Date();
				nextWeekDate.setDate(new Date().getDate() + 7);
				this.selectedDate = nextWeekDate;
			}
		}
	}

	getRoutesForDay() {
		let year = this.selectedDate.getFullYear();
		let month = this.selectedDate.getMonth();
		let day = this.selectedDate.getDate();

		this.facade.routeService
			.getRouteByYearAndMonthAndDay(year, month, day)
			.subscribe({
				next: (routes: Route[]) => {
					this.listRoute = [];
					routes.forEach((route) => {
						if (
							(route.plannedDistance || route.plannedTime) &&
							route.missions.length > 0
						) {
							this.listRoute.push(route);
						}
					});

					this.selectedRouteIndex = this.listRoute.findIndex((route: Route) => {
						return route.id === this.selectedRouteIndex;
					});

					this.filterListOfRouteToDisplay();
					this.initMap();
				},
				error: (err: ErrorResponse) => {
					this.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				},
				complete: () => {
					if (this.facade.dataStorageService.getParam('selectedRouteIndex')) {
						this.routeDropdowns.changes.subscribe((comps: QueryList<any>) => {
							const accordionSelected = this.routeDropdowns.get(
								this.selectedRouteIndex
							).nativeElement;

							// Get the dropdown down
							accordionSelected.childNodes[0].childNodes[0].click();

							// Changement du visuelle de l'accordéon et des properties
							const accordionSelectedHeader =
								accordionSelected.children[0].children[0];
							accordionSelectedHeader.setAttribute('aria-expanded', 'true');
							accordionSelectedHeader.classList.remove('collapsed');

							// 3ème mission de la route sélectionée : .childNodes[1].children[0].children[1].children[3]
							accordionSelected.scrollIntoView({ behavior: 'smooth' });
						});
						this.facade.dataStorageService.setParam('selectedRouteIndex', '');
					}
				}
			});
	}

	/**
	 * Méthode appeler par echart
	 * @param map
	 */
	onMapReady(map) {
		this.map = map;
	}

	/**
	 * Active ou désactive le mode plein écran
	 */
	onClickFullScreen() {
		this.isFullScreen = !this.isFullScreen;
		window.dispatchEvent(new Event('resize')); //Refresh la taille de la map
	}

	/**
	 * Recentre la carte sur la position de l'utilisateur ou de son centre
	 */
	onClickCenter() {
		this.map.setView(
			new LatLng(this.currentPosition[0], this.currentPosition[1]),
			15
		);
	}

	/**
	 * Zoom sur la map
	 */
	onClickZoomIn() {
		this.map.zoomIn();
	}

	/**
	 * Dezoom sur la map
	 */
	onClickZoomOut() {
		this.map.zoomOut();
	}

	/**
	 * Change le mode de dessin (itineraire ou vol d'oiseau)
	 */
	onClickDrawingMode() {
		this.isCrowflightSelected = !this.isCrowflightSelected;
		this.initMap();
	}

	/**
	 * Appel le nettoyage de la carte et le re-tracer des données
	 */
	initMap() {
		if (this.map) {
			this.cleanMap();
			this.createMapMarkers();
			this.isCrowflightSelected
				? this.drawCrowflight()
				: this.drawFilteredRouteOnMap();
		}
	}

	/**
	 * Appel les différentes fonction de creation de marker
	 */
	createMapMarkers() {
		this.drawCentersMarker();
		this.drawMissionPlacesMarker();
	}

	/**
	 * Supprime les layers de la carte
	 */
	cleanMap() {
		if (this.map) {
			if (this.layers) {
				this.layers.forEach((layer) => this.map.removeLayer(layer));
				this.layers.length = 0;
				this.missionMarkerList.forEach((marker) => {
					this.map.removeLayer(marker);
				});
				this.missionMarkerList.length = 0;
			}
		}
	}

	/**
	 * Dessine les marker/icon des missionPlace
	 */
	drawMissionPlacesMarker() {
		//Si il y a des routes à affichés
		if (this.listRouteToDrawOnMap && this.listRouteToDrawOnMap.length >= 1) {
			//Pour chaque mission, on dessine le marker du lieu de la mission
			this.listRouteToDrawOnMap.forEach((route) => {
				if (route.missions && route.missions.length >= 1) {
					route.missions.forEach((mission) => {
						const address: Address = !this.isSESSAD
							? mission.missionRequest?.beneficiaire?.address
							: mission.missionRequest?.missionPlace?.address;
						if (address && address.latitude && address.longitude) {
							const popupText = !this.isSESSAD
								? mission.missionRequest.beneficiaire.firstName +
								  ' ' +
								  mission.missionRequest.beneficiaire.lastName
								: mission.missionRequest.missionPlace?.nameDisplay;

							this.markerOptionsMission.icon = this.getMarkerOptionForMission(
								mission.state
							);

							this.missionMarkerList.push(
								marker(
									[address.latitude, address.longitude],
									this.markerOptionsMission
								)
									.on('click', (event) => {
										this.selectMarker(event as unknown as LocationEvent);
									})
									.bindPopup(
										`<p class="">${popupText}</p><span hidden>${mission.id}</span>`
									)
									.openPopup()
							);

							const popupTxt =
								mission.missionRequest.beneficiaire.area && this.isAreaActive
									? mission.missionRequest.beneficiaire.firstName +
									  ' ' +
									  mission.missionRequest.beneficiaire.lastName +
									  `<p class="">
									  <i class="bi bi-map-fill" aria-hidden="true"></i>&nbsp${mission.missionRequest.beneficiaire?.area.name}</p>`
									: !this.isSESSAD
									? mission.missionRequest.beneficiaire.firstName +
									  ' ' +
									  mission.missionRequest.beneficiaire.lastName
									: mission.missionRequest.missionPlace?.nameDisplay;

							this.missionMarkerList.push(
								marker(
									[address.latitude, address.longitude],
									this.markerOptionsMission
								)
									.on('click', (event) => {
										this.selectMarker(event as unknown as LocationEvent);
									})
									.bindPopup(
										`<p class="">${popupTxt}</p><span hidden>${mission.id}</span>`
									)
									.openPopup()
							);
							// }
						}
					});
				}
			});
			this.missionMarkerList.forEach((missionMarker) => {
				this.layers.push(missionMarker);
				this.map.addLayer(missionMarker);
			});
		}
	}

	getMarkerOptionForMission(state: State) {
		return State[state] === State.PENDING
			? this.missionDefaultIcon
			: State[state] === State.ON_THE_WAY
			? this.missionOnTheWayIcon
			: State[state] === State.IN_PROGRESS
			? this.missionInProgressIcon
			: State[state] === State.FINISHED
			? this.missionFinishedIcon
			: State[state].includes(State.CANCELED)
			? this.missionCanceledIcon
			: this.missionDefaultIcon;
	}

	selectMarker(event: LocationEvent) {
		const missionSelected: Mission = this.listRoute
			.map((route) => route.missions)
			.flat()
			.find(
				(mission) =>
					mission.missionRequest.beneficiaire.address.latitude ===
						event.latlng.lat &&
					mission.missionRequest.beneficiaire.address.longitude ===
						event.latlng.lng
			);

		const routeSelected: Route = this.listRoute.find((route) => {
			const missions = route.missions;
			// Est ce que la mission est dedans ?
			const mission = missions.find(
				(mission) =>
					mission.missionRequest.beneficiaire.address.latitude ===
						event.latlng.lat &&
					mission.missionRequest.beneficiaire.address.longitude ===
						event.latlng.lng
			);
			return mission ? true : false;
		});

		const routeSelectedIndex = this.listRoute.findIndex(
			(route) => route.id === routeSelected.id
		);
		const missionSelectedIndex = this.listRoute[
			routeSelectedIndex
		].missions.findIndex((mission) => mission.id === missionSelected.id);

		if (!this.isFullScreen) {
			this.selectRouteAndMission(missionSelectedIndex, routeSelectedIndex);
			//this.changeSelectedRouteIndex(routeSelectedIndex);
		}
	}

	selectRouteAndMission(
		missionSelectedIndex: number,
		routeSelectedIndex: number
	) {
		const accordionSelected: HTMLElement =
			this.accordionMission.nativeElement.children[routeSelectedIndex];

		// Reset des routes & missions non sélectionnées
		const accordionsNotSelected: any[] = Array.from(
			this.accordionMission.nativeElement.children
		).slice();
		accordionsNotSelected.splice(routeSelectedIndex, 1);
		accordionsNotSelected.forEach((accordionNotSelected) => {
			const accordionNotSelectedHeader =
				accordionNotSelected.children[0].children[0];
			accordionNotSelectedHeader.setAttribute('aria-expanded', 'false');
			accordionNotSelectedHeader.classList.add('collapsed');

			const listMissionsOfAccordionNotSelected =
				accordionNotSelected.children[1];
			listMissionsOfAccordionNotSelected.classList.remove('show');

			const missionsNotSelected = Array.from(
				listMissionsOfAccordionNotSelected.children[0].children[3].children
			).slice();
			missionsNotSelected.forEach((missionNotSelected: HTMLElement) => {
				missionNotSelected.classList.remove('mission-selected');
			});
		});

		// Sélection de la route et de la mission
		const accordionSelectedHeader = accordionSelected.children[0].children[0];
		accordionSelectedHeader.setAttribute('aria-expanded', 'true');
		accordionSelectedHeader.classList.remove('collapsed');

		const listMissionsOfAccordionSelected = accordionSelected.children[1];

		listMissionsOfAccordionSelected.classList.add('show');

		const missionSelectedHTML =
			listMissionsOfAccordionSelected.children[0].children[3].children[
				missionSelectedIndex
			];
		missionSelectedHTML.classList.add('mission-selected');

		// On reset les mssions de la route sélectionnée
		const missionsNotSelectedHTML = Array.from(
			listMissionsOfAccordionSelected.children[0].children[3].children
		).slice();
		missionsNotSelectedHTML.splice(missionSelectedIndex, 1);
		missionsNotSelectedHTML.forEach((missionNotSelected) => {
			missionNotSelected.classList.remove('mission-selected');
		});

		// scroll vers la mission sélectionnée
		missionSelectedHTML.scrollIntoView({ behavior: 'smooth' });
	}

	/**
	 * Dessine les marker/icon des centres ou du centre par defaut le cas echeant
	 */
	drawCentersMarker() {
		if (this.listCenter && this.listCenter.length >= 1) {
			//Centres
			const centers: Marker[] = [];
			this.listCenter?.forEach((center) => {
				if (
					center.address &&
					center.address.latitude &&
					center.address.longitude
				) {
					centers.push(
						marker(
							[center.address.latitude, center.address.longitude],
							this.markerOptionsCentre
						)
							.bindPopup(`<p class="">${center.name}</p>`)
							.openPopup()
					);
				}
			});
			centers.forEach((center) => {
				this.map.addLayer(center);
				center.addTo(this.map);
			});
		} else {
			const center = marker(
				[this.currentPosition[0], this.currentPosition[1]],
				this.markerOptionsCentre
			)
				.bindPopup(
					`<p class="">${
						this.currentPosition[0] === this.sessad_coord[0]
							? this.sessad_name
							: 'Ma position'
					}</p>`
				)
				.openPopup();
			this.map.addLayer(center);
			this.layers.push(center);
		}
	}

	/**
	 * Tracer entre les éléments des routes à vol d'oiseau
	 */
	drawCrowflight() {
		if (this.listRouteToDrawOnMap && this.listRouteToDrawOnMap.length >= 1) {
			this.listRouteToDrawOnMap.forEach((route) => {
				if (route.missions && route.missions.length >= 1) {
					// ordonner routes en fonction de la position
					route.missions.sort((a, b) => a.plannedPosition - b.plannedPosition);
					//Pour chaque mission l'on fait un tracer reliant les étapes de la mission (centre si première mission, lieu de la mission, lieu de la suivante mission ou centre si dernière mission)
					route.missions.forEach((mission, index) => {
						const addressMission: Address = !this.isSESSAD
							? mission?.missionRequest?.beneficiaire?.address
							: mission?.missionRequest?.missionPlace?.address;

						const missionLatLong: LatLngExpression = [
							addressMission.latitude,
							addressMission.longitude
						];
						const centerLatLong: LatLngExpression = [
							this.currentPosition[0],
							this.currentPosition[1]
						];

						const isFirstMission = index === 0 ? true : false;
						const hasNextMission =
							index + 1 < route.missions.length ? true : false;

						const addressNextMission: Address = hasNextMission
							? !this.isSESSAD
								? route.missions[index + 1]?.missionRequest?.beneficiaire
										?.address
								: route.missions[index + 1]?.missionRequest?.missionPlace
										?.address
							: null;
						const nextMissionLatLong: LatLngExpression = addressNextMission
							? [addressNextMission.latitude, addressNextMission.longitude]
							: null;
						const missionCrowflight = polyline(
							[
								isFirstMission ? centerLatLong : null, // départ du centre si première mission
								missionLatLong,
								hasNextMission ? nextMissionLatLong : centerLatLong // retour au centre si dernière mission
							],
							{
								color: this.getColorFromId(route?.id)
							}

							// @ts-ignore
						).arrowheads({
							yawn: 20,
							size: '5%'
						});
						// on filtre les valeurs nulles du crowFlight si existantes
						missionCrowflight.setLatLngs(
							(missionCrowflight.getLatLngs() as LatLng[]).filter(
								(x) => x !== null
							)
						);

						this.layers.push(missionCrowflight);
						this.map.addLayer(missionCrowflight);
					});
				}
			});
		}
	}

	/**
	 * Tracer entre les éléments des routes avec un moteur de routing
	 */
	drawFilteredRouteOnMap() {
		if (this.listRouteToDrawOnMap && this.listRouteToDrawOnMap.length >= 1) {
			//Pour chaque route l'on dessine le trajet transmi par le back
			this.listRouteToDrawOnMap.forEach((route) => {
				if (route.missions && route.missions.length >= 1) {
					this.facade.routeService
						.getRouteItinerary(route.id)
						.subscribe((etapes) => {
							const missionCrowflight = polyline(
								[etapes as LatLngExpression[]],
								{
									color: this.getColorFromId(route?.id)
								}
							) // @ts-ignore
								.arrowheads({
									yawn: 20,
									size: '50%'
								});

							this.layers.push(missionCrowflight);
							this.map.addLayer(missionCrowflight);
						});
				}
			});
		}
	}

	/**
	 * Reinitialise les données et les filtres
	 * 	- si aucune route n'est sélectionner (dans le front), la liste des routes à afficher est la liste des routes récupérers par le back
	 * 	- si une route est sélectionner, la liste des routes à afficher ne contiendra que celle-ci
	 */
	filterListOfRouteToDisplay() {
		//Filtre selon état de tournée
		this.listRoute = this.listRoute.filter(
			(el) => State[el.state] === this.currentRouteStateSelected
		);

		this.listRouteToDrawOnMap = [...this.listRoute];
		if (
			!isNaN(this.selectedRouteIndex) &&
			this.selectedRouteIndex !== null &&
			this.selectedRouteIndex >= 0 &&
			this.selectedRouteIndex < this.listRouteToDrawOnMap.length
		) {
			this.listRouteToDrawOnMap = [
				this.listRouteToDrawOnMap[this.selectedRouteIndex]
			];
		}
	}

	/**
	 * Change l'index de la route sélectionner lorsqu'on clique sur l'accordeon dans la vue
	 * @param index
	 */
	changeSelectedRouteIndex(index: number) {
		this.selectedRouteIndex = index;
		this.filterListOfRouteToDisplay();
		this.initMap();
	}

	/**
	 * Renvois une couleur ex : '#262c5e' en fonction d'un id
	 * @param id
	 * @returns
	 */
	getColorFromId(id: number) {
		const colorNumber = id % this.colorsPath.length;
		return this.colorsPath[colorNumber];
	}

	/**
	 * Fonction de validation d'une route, si elle réussit l'utilisateur est redirigé vers la vue de la route validée
	 * @param routeIndex index de la route dans listRoute
	 */
	validateRoute(routeIndex: number) {
		this.isBtnValidateRouteClicked = true;
		if (!this.isSESSAD && this.listRoute[routeIndex]) {
			this.facade.routeService
				.validerRoute(this.listRoute[routeIndex].id)
				.subscribe({
					next: (succ) => {
						this.isBtnValidateRouteClicked = false;
						this.router.navigate([], {
							relativeTo: this.route
						});
					},
					error: (err) => {
						this.isBtnValidateRouteClicked = false;
					}
				});
		}
	}

	/**
	 * Fonction d'invalidation d'une route
	 * @param routeIndex index de la route dans listRoute
	 */
	invalidateRoute(routeIndex: number) {
		this.isBtnValidateRouteClicked = true;
		if (!this.isSESSAD && this.listRoute[routeIndex]) {
			this.facade.routeService
				.invaliderRoute(this.listRoute[routeIndex].id)
				.subscribe({
					next: (succ) => {
						this.isBtnValidateRouteClicked = false;
						this.router.navigate([], {
							relativeTo: this.route
						});
					},
					error: (err) => {
						this.isBtnValidateRouteClicked = false;
					}
				});
		}
	}

	/**
	 * Ouvre la modal de suppression pour la mission à l'index missionIndex de la route à l'index routeIndex de listRoute
	 * @param template
	 * @param missionIndex positon de la mission dans le tableau de la route correspondante
	 * @param routeIndex position de la route dans listRoute
	 */
	openModalSuppression(
		template: TemplateRef<any>,
		missionIndex: number,
		routeIndex: number
	) {
		if (routeIndex >= 0 && this.listRoute && this.listRoute[routeIndex]) {
			if (
				missionIndex >= 0 &&
				this.listRoute[routeIndex].missions &&
				this.listRoute[routeIndex].missions[missionIndex]
			) {
				this.selectedMisionForReaffectOrDelete =
					this.listRoute[routeIndex]?.missions[missionIndex];
				if (this.selectedMisionForReaffectOrDelete) {
					this.modalRef = this.modalService.show(
						template,
						Object.assign({}, { class: 'detail-route-custom-modal-pos' })
					);
				}
			}
		}
	}

	/**
	 * Supprime une mission d'une route
	 */
	deleteMissionFromRoute() {
		if (this.selectedMisionForReaffectOrDelete) {
			this.isBtnSupprimerClicked = true;
			this.facade.missionService
				.desaffecter(this.selectedMisionForReaffectOrDelete.id)
				.subscribe({
					next: () => {
						this.isBtnSupprimerClicked = false;
						this.modalRef?.hide();
						this.getRoutesForDay();
						this.deleteMarkerFromMap(this.selectedMisionForReaffectOrDelete.id);
					},
					error: (err: ErrorResponse) => {
						this.isBtnSupprimerClicked = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
					}
				});
		}
	}

	openModalReaffectationRoute(template: TemplateRef<any>, routeIndex: number) {
		this.selectedRouteForReaffect = this.listRoute[routeIndex];
		this.filterAvailableEmployeeRoute();
		this.idEmployeeReafectation = null;
		this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
	}

	/**
	 * Filtre les employee displonible (ceux qui ne sont pas affecter)
	 */
	filterAvailableEmployeeRoute() {
		this.listEmployeeAvailableRoute = this.listEmployee.filter((employee) => {
			// Vérifier si l'employé est déjà affecté à une route avec des missions non vides
			const isAssignedToNonEmptyRoute = this.listRoute.some((route) => {
				return (
					route.planning?.employee?.id === employee.id &&
					route.missions &&
					route.missions.length > 0
				);
			});

			if (isAssignedToNonEmptyRoute) {
				return false;
			}

			// Vérifier si l'employé possède toutes les compétences requises pour chaque mission de la route à affecter
			const requiredSkills = new Set<string>();
			this.selectedRouteForReaffect.missions.forEach((mission) => {
				mission.missionRequest.careSkills.forEach((skill) =>
					requiredSkills.add(skill.name)
				);
			});

			const employeeSkills = new Set(
				employee.careSkills.map((skill) => skill.name)
			);

			// Vérifier si l'employé possède toutes les compétences requises
			for (let skill of requiredSkills) {
				if (!employeeSkills.has(skill)) {
					return false;
				}
			}

			return true;
		});
	}

	/**
	 * Affecte une route à un employee
	 */
	reaffecterRoute() {
		if (
			this.selectedRouteForReaffect &&
			this.idEmployeeReafectation &&
			parseInt(this.idEmployeeReafectation.toString()) >= 0
		) {
			const employee = this.listEmployee.find(
				(employee) =>
					employee.id === parseInt(this.idEmployeeReafectation.toString())
			);
			if (employee) {
				this.isBtnReaffecterClicked = true;
				this.facade.routeService
					.reaffecter(
						this.selectedRouteForReaffect.id,
						this.idEmployeeReafectation
					)
					.subscribe({
						next: (succ) => {
							this.isBtnReaffecterClicked = false;
							this.modalRef.hide();
							this.getRoutesForDay();
						},
						error: (err: ErrorResponse) => {
							this.isBtnReaffecterClicked = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.response ? err.error.response : '',
								err.status
							);
						}
					});
			}
		}
	}

	openModalReaffectationMission(
		template: TemplateRef<any>,
		routeIndex: number,
		missionIndex: number
	) {
		this.selectedMisionForReaffectOrDelete =
			this.listRoute[routeIndex].missions[missionIndex];
		this.filterAvailableEmployeeMission(this.listRoute[routeIndex]);
		this.idEmployeeReafectation = null;
		this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
	}

	/**
	 * Filtre les employee disponible à la réaffectation de la mission (ie. ceux qui ont déjà une route le même jour)
	 * @param currentRoute
	 */
	filterAvailableEmployeeMission(currentRoute: Route) {
		if (currentRoute?.planning?.employee) {
			this.listEmployeeAvailableMission = this.listRoute
				.filter(
					(r) =>
						r?.planning?.employee &&
						r.planning.employee.id !== currentRoute.planning.employee.id &&
						(hasEmployeeSkill(
							r.planning.employee,
							CompetencesElementaires.INFIRMIER
						) ||
							hasEmployeeSkill(
								r.planning.employee,
								CompetencesElementaires.AIDESOIGNANT
							))
				)
				.map((r) => r.planning.employee);
		} else {
			this.listEmployeeAvailableMission = [];
		}
	}

	/**
	 * Reaffecte une mission à un employee
	 */
	reaffecterMission() {
		if (
			this.selectedMisionForReaffectOrDelete &&
			this.idEmployeeReafectation &&
			parseInt(this.idEmployeeReafectation.toString()) >= 0
		) {
			const employee = this.listEmployee.find(
				(employee) =>
					employee.id === parseInt(this.idEmployeeReafectation.toString())
			);
			if (employee) {
				this.isBtnDeplacerClicked = true;
				const plannerId = this.user.employee.id;

				this.facade.missionService
					.changeMission(
						this.selectedMisionForReaffectOrDelete.id,
						employee.id,
						plannerId
					)
					.subscribe({
						next: (succ) => {
							this.isBtnDeplacerClicked = false;
							this.modalRef.hide();
							this.getRoutesForDay();
						},
						error: (err: ErrorResponse) => {
							this.isBtnDeplacerClicked = false;
							this.facade.toastService.createHttpErrorToast(
								err.error.response ? err.error.response : '',
								err.status
							);
						}
					});
			}
		}
	}

	triggerPopupOnMap(missionId: number): void {
		let regex = new RegExp(`(?<=<span hidden>)(.*?)(?=</span>)`);
		this.missionMarkerList.some((missionMarker) => {
			// Get the content of the popup
			const missionPopupContent = missionMarker
				.getPopup()
				.getContent()
				.toString();
			// Get the id from the hidden span of the popup content
			const missionIdAsList: string[] = [...regex.exec(missionPopupContent)];

			// Si on trouve bien l'id (peut ne pas être là en cas de bug)
			if (missionIdAsList.length > 0) {
				// On test si c'est celui de la mission sélectionnée
				if (missionIdAsList[0] === missionId.toString()) {
					// Si oui, afficher le popup sur la carte
					missionMarker.openPopup();
					this.map.setView(
						new LatLng(
							missionMarker.getLatLng().lat,
							missionMarker.getLatLng().lng
						),
						15
					);
					return true;
				}
			}
			return false;
		});

		let missionSelected = null;
		let routeSelected = null;
		routeSelected = this.listRoute.find((route) => {
			const missionToFind = route.missions.find(
				(mission) => mission.id === missionId
			);
			if (missionToFind) {
				missionSelected = missionToFind;
				return route;
			}
		});

		const routeSelectedIndex = this.listRoute.findIndex(
			(route) => route.id === routeSelected.id
		);
		const missionSelectedIndex = this.listRoute[
			routeSelectedIndex
		].missions.findIndex((mission) => mission.id === missionSelected.id);

		this.selectRouteAndMission(missionSelectedIndex, routeSelectedIndex);
	}

	deleteMarkerFromMap(missionId: number): void {
		let regex = new RegExp(`(?<=<span hidden>)(.*?)(?=</span>)`);
		this.missionMarkerList = this.missionMarkerList.filter((missionMarker) => {
			// Get the content of the popup
			const missionPopupContent = missionMarker
				.getPopup()
				.getContent()
				.toString();
			// Get the id from the hidden span of the popup content
			const missionIdAsList: string[] = [...regex.exec(missionPopupContent)];

			// Si on trouve bien l'id (peut ne pas être là en cas de bug)
			if (missionIdAsList.length > 0) {
				// On test si c'est celui de la mission sélectionnée
				if (missionIdAsList[0] === missionId.toString()) {
					missionMarker.remove();
					return false;
				}
			}
			return true;
		});
	}

	reorderRoute(routeId: number) {
		// 1 - open component
		const initialState = { missionList: this.listRoute[routeId].missions };
		this.modalRef = this.modalService.show(
			ReorderRouteComponent,
			Object.assign({}, { class: 'modal-lg', initialState })
		);

		// Lors de la fermeture de la modale, mettre à jour l'ordre des missions et reinit la map
		this.modalRef.onHidden.subscribe(() => {
			this.listRoute[routeId].missions = this.modalRef.content.missionList;
			this.filterListOfRouteToDisplay();
			this.initMap();
		});
	}

	calculTotal(paramToCalc) {
		let sum = 0;
		for (let i = 0; i < this.listRoute.length; i++) {
			if (paramToCalc === 'dist') {
				sum += this.listRoute[i].plannedDistance;
			} else {
				sum += this.listRoute[i].plannedTime;
			}
		}
		if (paramToCalc === 'dist') {
			return sum / 1000;
		} else {
			return sum;
		}
	}
}
